import type { FC } from "react";
import React from "react";
import {
  createTrackingPageProvider,
  useTracking,
  useTranslation,
} from "@edreamsodigeo/frontend-core";
import { Link } from "@edreamsodigeo/prisma-design-system";

import { useSubscriptionInfoBundle } from "~/clientState/hooks/useSubscriptionInfoBundle";
import PrimeSubscriptionModalProvider, {
  usePrimeSubscriptionModalUI,
} from "~/clientState/providers/PrimeSubscriptionModalProvider";
import {
  ActionsEnum,
  CategoryEnum,
  trackingLabelsPrimePage,
} from "~/components/acquisition/DiscoverMoreLink/config/tracking";
import { SubscriptionOfferPeriod } from "~/generated/graphql";
import DrawerPrimeSinglePage from "~/components/acquisition/Lightbox";

export const pageMapper = (): string => "/BF/dynpack/prime/";

const TrackingProvider = createTrackingPageProvider({
  category: CategoryEnum.DP_PRIME_FARES,
  pageMapper,
  pageViewName: "",
});

const DiscoverMoreLinkPrimePageDP: FC = () => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();

  const { wasPrimePriceSelected, isUserLogged } = useSubscriptionInfoBundle({
    offerPeriod: SubscriptionOfferPeriod.FreeTrial,
  });
  const { open: openModalSubscription } = usePrimeSubscriptionModalUI();

  const trackingProps = {
    wasPrimeSelectedInResults: wasPrimePriceSelected,
    isUserLogged: isUserLogged,
    subscriptionPeriod: "free_trial",
  };

  const onLinkClick = (): void => {
    trackEvent({
      label: trackingLabelsPrimePage.onMoreInfoClick(trackingProps),
      category: CategoryEnum.DP_PRIME_FARES,
      action: ActionsEnum.PRIME_SELECTION,
    });
    openModalSubscription();
  };

  return (
    <TrackingProvider>
      <Link
        onClick={onLinkClick}
        size={"small"}
        sx={{ textDecoration: "none" }}
      >
        {t("membership.discoverMoreLink.text")}
      </Link>
      <DrawerPrimeSinglePage />
    </TrackingProvider>
  );
};

const ComponentWithModalProvider: FC = () => (
  <PrimeSubscriptionModalProvider initialState={false}>
    <DiscoverMoreLinkPrimePageDP />
  </PrimeSubscriptionModalProvider>
);

export default ComponentWithModalProvider;
